import { useEffect } from 'react'
import { useReactiveVar } from '@apollo/client'
import { userVar } from 'shared/store/user'
import { useConsent, applyConsent } from '../hooks/use-consent'

/**
 * Applies a stored choice on load and re-reports it when the identity changes
 * (FE-330): a login turns the guest's choice into the user's.
 */
export const ConsentEffect = () => {
  const { consent, syncConsent } = useConsent()
  const userId = useReactiveVar(userVar)?.id ?? null

  useEffect(() => {
    if (consent) applyConsent(consent)
  }, [consent])

  useEffect(() => {
    if (userId && consent) syncConsent(consent)
    // NOTE: only the identity change should re-send; the choice itself is sent
    // by `grant`
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId])

  return null
}
